<script>
export default {
  name: 'AdminEmptyState',
  props: {
    title: {
      type: String,
      default: '데이터가 없습니다.',
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div class="admin-empty-state admin-page-card">
    <v-icon size="28" color="secondary">mdi-database-off-outline</v-icon>
    <p class="admin-empty-state__title">{{ title }}</p>
    <p v-if="description" class="admin-empty-state__description">{{ description }}</p>
    <slot />
  </div>
</template>

<style scoped>
.admin-empty-state {
  padding: var(--admin-space-6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--admin-space-2);
}

.admin-empty-state__title {
  margin: 0;
  font-weight: 600;
}

.admin-empty-state__description {
  margin: 0;
  color: var(--admin-color-text-secondary);
  font-size: 13px;
}
</style>
